import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const ShippingTruck: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--shipping-truck')}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={icon}
  >
    <path
      d="M20.75 8.25v2h3.902l4.098 7.001v5.499h-2.259a3.5 3.5 0 01-6.982 0H12.49a3.5 3.5 0 01-6.982 0H3.25V8.25h17.5zM9 20.5a2 2 0 100 4 2 2 0 000-4zm14 0a2 2 0 100 4 2 2 0 000-4zM19.25 9.75H4.75v6.499l12.111.001v1.5H4.75v3.5h.98a3.501 3.501 0 016.54 0h6.98V9.75zm4.542 2H20.75v8.07a3.501 3.501 0 015.52 1.431l.98-.001v-3.591l-.093-.159H22v-4h2.816l-1.024-1.75zm1.609 2.75H23v2h3.572l-1.171-2z"
      fill="#000"
      fillRule="nonzero"
    />
  </svg>
);

export default ShippingTruck;
